import React from 'react';

import Alert from '../../UI/Alert';
import { CodVendedorAlertProps } from './types';

const CodVendedorAlert: React.FC<CodVendedorAlertProps> = ({
  isOpen,
  setOpen,
  setCodVendedor,
}) => {
  return (
    <Alert
      isOpen={isOpen}
      header="Código de vendedor"
      message="Ingrese el código de vendedor (opcional)"
      onDidDismiss={() => setOpen(false)}
      inputs={[
        {
          name: 'codVend',
          type: 'text',
          placeholder: 'Código',
        },
      ]}
      buttons={[
        {
          text: 'No tengo uno',
          role: 'cancel',
          handler: () => {
            setCodVendedor('');
            setOpen(false);
          },
        },
        {
          text: 'Usar código',
          handler: (data) => {
            setCodVendedor(data.codVend ?? '');
            setOpen(false);
          },
        },
      ]}
    />
  );
};

export default React.memo(CodVendedorAlert);
